import { render, staticRenderFns } from "./TrPrivacyPolicy.vue?vue&type=template&id=9a71345a&scoped=true"
import script from "./TrPrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./TrPrivacyPolicy.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "9a71345a",
  null
  ,true
)

export default component.exports